import BiDashboard from '../components/Bi/Dashboard/BiDashboard';

// 企业管理相关路由
const biRoutes = [
    // 商业智能 - 首页
    { path: '', element: <BiDashboard /> },
];

export default biRoutes;
